import { useMediaQuery } from "@mui/material";
import { Share } from "../../components";
import style from "./block.module.scss";
import { defineBlock } from "@smartfire/js-block-engine";

function Block({ title, image, date, author, readingTime }) {
  const isDesktop = useMediaQuery("(min-width:" + style.tabletBreakpoint + ")");

  return (
    <div className={style.block}>
      <h1 className={style.title}>{title}</h1>

      <Share
        name={author}
        date={date}
        isDesktop={isDesktop}
        time={readingTime}
        imageurl={image}
        titlePost={title}
      />
    </div>
  );
}

export default defineBlock({
  Block: Block,
});
